module.exports = "/_next/static/images/bg-a00f11294b835ecdf11ff2b368f86637.png";